var _path, _g, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDangerT(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_67_1585",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 3,
    width: 21,
    height: 19
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 3H22.0137V21.1855H2V3Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_67_1585)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0125 4.5C11.5365 4.5 11.1125 4.746 10.8745 5.159L3.67652 17.724C3.44253 18.134 3.44453 18.623 3.68152 19.032C3.91852 19.441 4.34253 19.686 4.81553 19.686H19.1985C19.6705 19.686 20.0945 19.441 20.3315 19.032C20.5695 18.623 20.5715 18.134 20.3355 17.724L13.1505 5.159C12.9135 4.746 12.4895 4.5 12.0125 4.5ZM19.1985 21.186H4.81553C3.80152 21.186 2.89253 20.662 2.38353 19.784C1.87453 18.907 1.87153 17.858 2.37453 16.979L9.57452 4.413C10.0805 3.528 10.9915 3 12.0125 3H12.0135C13.0335 3 13.9465 3.529 14.4525 4.415L21.6385 16.979C22.1415 17.858 22.1385 18.907 21.6295 19.784C21.1205 20.662 20.2115 21.186 19.1985 21.186Z",
    fill: "black"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0039 14.164C11.5899 14.164 11.2539 13.828 11.2539 13.414V10.314C11.2539 9.89996 11.5899 9.56396 12.0039 9.56396C12.4179 9.56396 12.7539 9.89996 12.7539 10.314V13.414C12.7539 13.828 12.4179 14.164 12.0039 14.164Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.006 17.499C11.453 17.499 11.001 17.052 11.001 16.499C11.001 15.946 11.444 15.499 11.996 15.499H12.006C12.559 15.499 13.006 15.946 13.006 16.499C13.006 17.052 12.559 17.499 12.006 17.499Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDangerT);
export default __webpack_public_path__ + "static/media/DangerT.9637b72113d700bb02d906f2c65c5dd3.svg";
export { ForwardRef as ReactComponent };